import { Feature } from "ol";
import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import CircleStyle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import { useContext, useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks";
import MapContext from "../MapContext";

export default function Highlight() {
    const map = useContext(MapContext)
    const highlightGeom = useAppSelector(state => state.mapState.highlightGeom);
    const highlightAll = useAppSelector(state => state.mapState.highlightAll);
    const features = useAppSelector(state => state.mapState.highlightGeomForTransportation);
    const [highlightLayer, sethighlightLayer] = useState<VectorLayer<VectorSource> | null>(null)
    const [highlightLayer2, sethighlightLayer2] = useState<VectorLayer<VectorSource> | null>(null)

    useEffect(() => {
        const layer = new VectorLayer({
            zIndex: 1000,
            source: new VectorSource(),
            style: new Style({
                stroke: new Stroke({
                    color: '#00fffe',
                    width: 2
                }),
                fill: new Fill({
                    color: '#00fffe60',

                }),
                image: new CircleStyle({
                    radius: 15,
                    fill: new Fill({
                        color: '#00fffe95',

                    }),
                })
            })
        })
        const layer2 = new VectorLayer({
            zIndex: 1000,
            source: new VectorSource(),
            style: new Style({
                stroke: new Stroke({
                    color: '#00fffe',
                    width: 5
                }),
                fill: new Fill({
                    color: '#00fffe',

                }),
                image: new CircleStyle({
                    radius: 15,
                    fill: new Fill({
                        color: '#00fffe95',

                    }),
                })
            })
        })

        sethighlightLayer(layer);
        sethighlightLayer2(layer2);
        map.addLayer(layer);
        map.addLayer(layer2);

    }, [])


    useEffect(() => {
        if (highlightLayer) {
            highlightLayer.getSource()?.clear();
            if (highlightGeom) {
                let geom;
                switch (highlightGeom.type) {
                    case 'Point':
                        geom = new Point(highlightGeom.coordinates)
                        break;
                    case 'LineString':
                        geom = new LineString(highlightGeom.coordinates)
                        break;
                    case 'Polygon':
                        geom = new Polygon(highlightGeom.coordinates)
                        break;
                    case 'MultiPoint':
                        geom = new MultiPoint(highlightGeom.coordinates)
                        break;
                    case 'MultiLineString':
                        geom = new MultiLineString(highlightGeom.coordinates)
                        break;
                    case 'MultiPolygon':
                        geom = new MultiPolygon(highlightGeom.coordinates)
                        break;
                    default:
                        break;
                }

                const translated = geom?.transform('EPSG:4326', 'EPSG:3857');
                const feature :any = new Feature(translated);
                highlightLayer.getSource()?.addFeature(feature);
            }
        }
    }, [highlightGeom])

    useEffect(() => {
        if (highlightAll) {
            let geom: any;
            highlightAll.map((highlightGeom: any) => {
                if (highlightGeom) {
                    if (highlightGeom.geometry.type === 'GeometryCollection') {
                        highlightGeom.geometry.geometries.map((geometry: any) => {
                            switch (geometry.type) {
                                case 'Point':
                                    geom = new Point(geometry.coordinates)
                                    break;
                                case 'LineString':
                                    geom = new LineString(geometry.coordinates)
                                    break;
                                case 'Polygon':
                                    geom = new Polygon(geometry.coordinates)
                                    break;
                                case 'MultiPoint':
                                    geom = new MultiPoint(geometry.coordinates)
                                    break;
                                case 'MultiLineString':
                                    geom = new MultiLineString(geometry.coordinates)
                                    break;
                                case 'MultiPolygon':
                                    geom = new MultiPolygon(geometry.coordinates)
                                    break;
                                default:
                                    break;
                            }
                            const translated = geom?.transform('EPSG:4326', 'EPSG:3857');
                            const feature :any = new Feature(translated);
                            highlightLayer?.getSource()?.addFeature(feature);
                        })
                    }
                    else {

                        switch (highlightGeom.geometry.type) {
                            case 'Point':
                                geom = new Point(highlightGeom.geometry.coordinates)
                                break;
                            case 'LineString':
                                geom = new LineString(highlightGeom.geometry.coordinates)
                                break;
                            case 'Polygon':
                                geom = new Polygon(highlightGeom.geometry.coordinates)
                                break;
                            case 'MultiPoint':
                                geom = new MultiPoint(highlightGeom.geometry.coordinates)
                                break;
                            case 'MultiLineString':
                                geom = new MultiLineString(highlightGeom.geometry.coordinates)
                                break;
                            case 'MultiPolygon':
                                geom = new MultiPolygon(highlightGeom.geometry.coordinates)
                                break;
                            default:
                                break;
                        }
                        const translated = geom?.transform('EPSG:4326', 'EPSG:3857');
                        const feature :any = new Feature(translated);
                        highlightLayer?.getSource()?.addFeature(feature);
                    }
                }
            })

        }
        else {
            highlightLayer?.getSource()?.clear();
        }
    }, [highlightAll])

    //Seçilen feature'ın ulaşım bilgilerine tıklandığında en yakın ulaşım noktalarının haritada gösterilmesi.
    useEffect(() => {
        if (highlightLayer2) {
            highlightLayer2.getSource()?.clear();
            if (features) {
                for (const feature of features) {
                    highlightLayer2.getSource()?.addFeature(feature);
                }
            }
        }
    }, [features])

    return (
        <></>
    )
}
